<template>
  <section class="participantes">
    <div v-if="itemsRestaurantes.length > 0" class="row py-3">
      <div class="col-12">
        <h2 class="pb-2 pt-3 text-center" :style="{ color: color_jornada }">
          {{ $t("restaurantes") }}
        </h2>
      </div>
    </div>
    <!--fin row-->

    <div class="row d-flex justify-content-center g-4">
      <comp_elemento_lista_restaurantes
        v-for="restaurante in itemsRestaurantes"
        :key="restaurante.idParticipante"
        :restaurante="restaurante"
        :nombre_seo_jornada="nombre_seo_jornada"
        :nombre_jornada="nombre_jornada"
      ></comp_elemento_lista_restaurantes>
    </div>

    <div v-if="itemsRestaurantes.length > 0" class="row mt-5">
      <div class="col-12">
        <comp_paginate
          id="unit"
          :page-count="num_paginas"
          :page-range="rango_paginador"
          :margin-pages="0"
          :initial-page="1"
          :click-handler="cambia_de_pagina"
          :prev-text="'Anterior'"
          :next-text="'Siguiente'"
          :prev-class="'ignore'"
          :next-class="'ignore'"
          :disabled-class="'ignore'"
        >
        </comp_paginate>
      </div>
    </div>

    <!--fin row-->
  </section>
</template>

<script>
//TODO importalo en el composition API
import VuejsPaginateNext from "./comp_Paginate.vue";

export default {
  data() {
    return {
      page: 1,
    };
  },
  components: {
    comp_paginate: VuejsPaginateNext,
  },
};
</script>

<script setup>
/* eslint-disable */
import { onMounted, ref, watch } from "vue";
import { i18n } from "@/boot/i18n";
import comp_elemento_lista_restaurantes from "./comp_elemento_lista_restaurantes.vue";

const props = defineProps({
  restaurantes: { type: Array },
  nombre_seo_jornada: { type: String },
  nombre_jornada: { type: String },
  color_jornada: { type: String },
  registros_pagina: { type: Number },
});

let itemsRestaurantes = ref([]);

// ---------  define el paginador ------------
let pagina = ref(1); // Página solicitada
let registros_pagina = props.registros_pagina > 0 ? props.registros_pagina : 8; // Validación para evitar 0
let rango_paginador = 5; // número máximo de botones en el paginador
let num_paginas = ref(1);

// este recorta el array de datos devolviendo solo los datos de la pagina solicitada
function obtenerRegistrosPorPagina(data, registros_pagina, pagina) {
  const inicio = (pagina - 1) * registros_pagina;
  return data.slice(inicio, inicio + registros_pagina);
}

function actualizarPaginacion() {
  num_paginas.value = Math.ceil(
    props.restaurantes.length / registros_pagina
  );
  itemsRestaurantes.value = obtenerRegistrosPorPagina(
    props.restaurantes,
    registros_pagina,
    pagina.value
  );
  
}

onMounted(() => {
  actualizarPaginacion();
  });

watch(
  () => props.restaurantes,
  (restaurantesNew) => {
    itemsRestaurantes.value = restaurantesNew;
    pagina.value = 1; 
    registros_pagina = props.registros_pagina || 8;
    actualizarPaginacion();
  },
  { deep: true }
  
);

// recibe el numero de pagina y actualiza la lista de datos a mostrar en el front despues de hacer click en la paginacion
function cambia_de_pagina(pageNum) {
  pagina.value = pageNum;
  itemsRestaurantes.value = obtenerRegistrosPorPagina(
    props.restaurantes,
    registros_pagina,
    pagina.value
  );
  
}
</script>

<style scoped lang="scss">
.jornada_ficha h2 {
  color: $color-evento;
  text-transform: uppercase;
  font-size: clamp(1.063rem, 0.849rem + 1.07vw, 2.25rem);
  letter-spacing: 2px;
}
</style>
